import { render, staticRenderFns } from "./DatosCliente.vue?vue&type=template&id=1c1a061b"
import script from "./DatosCliente.vue?vue&type=script&lang=js"
export * from "./DatosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports